import { render, staticRenderFns } from "./PageTemplate.vue?vue&type=template&id=7edac475&"
import script from "./PageTemplate.vue?vue&type=script&lang=js&"
export * from "./PageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\webinane\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7edac475')) {
      api.createRecord('7edac475', component.options)
    } else {
      api.reload('7edac475', component.options)
    }
    module.hot.accept("./PageTemplate.vue?vue&type=template&id=7edac475&", function () {
      api.rerender('7edac475', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/PageTemplate.vue"
export default component.exports